const apiAddress = 'http://localhost:28084/'

const apiOption = {
	method:'GET',
	mode: 'cors',
}

const apiControlCall = async (command, id, callback=null,failure=null) => {
	try {
		const response = await fetch(apiAddress + command + '/'+id, apiOption)
		const json = await response.json()
		if(callback!==null) callback(json)
	} catch(e) {
		console.log(e)
		alert('ローカルコントローラーが起動していません。\nCommand:'+command + '/'+id)
		if(failure!==null) failure()
	}
}
export default apiControlCall
